export default __webpack_public_path__ + "static/media/move-down.83dc06d8.svg";